// extracted by mini-css-extract-plugin
export var header = "_sa-1";
export var maskBottom = "_sa-6";
export var maskMiddle = "_sa-7";
export var maskTop = "_sa-5";
export var root = "_sa-0";
export var scrollDownButton = "_sa-3";
export var scrollDownButtonHidden = "_sa-4";
export var viewport = "_sa-2";